import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/* eslint-disable no-case-declarations */
import React, { createContext, useContext, useReducer, useMemo, useEffect } from 'react';
import { PimMessagingContext } from '@mummssoftware/pim-messenger';
import { SET_IDG_CONTENT, SET_PATIENT_IDG_MANIFEST, SET_REVIEW_COMPLETE, SET_LAST_IDG_INFO, SET_ALL_IDG_QUESTIONNAIRES, SET_DOCUMENT_ID, SET_DOCUMENT_DATA, RESET_IDG_DATA, SET_LOADER, SET_IDG_LIST_DATA } from './constants';
import { formatDocumentData } from './utils';
/* Context for managing messaging to and from PIM */

// default dto between dashboard and idg document.
export const defaultIDGContent = {
  patientID: null,
  from: null,
  to: null,
  patientNumber: null,
  idgSourceKey: null,
  agency: null,
  idgReviewComplete: null,
  idgNarratives: null,
  idgMeetingID: null,
  idgRoleAttestationDone: 0,
  allIdgQuestionnaires: null
};
const initialState = {
  idgContent: defaultIDGContent,
  lastidgContent: null,
  patientIdgManifests: null,
  allIdgQuestionnaires: null,
  documentData: null,
  documentID: null,
  showLoader: false,
  idgList: []
};
const initIDGGlobalContext = {
  idgContent: defaultIDGContent,
  lastidgContent: null,
  patientIdgManifests: null,
  allIdgQuestionnaires: null,
  documentData: null,
  documentID: null,
  showLoader: false,
  idgList: []
};
export const IDGGlobalContextReducer = (state, action) => {
  let newState = _objectSpread({}, state);

  const {
    payload
  } = action;

  switch (action.type) {
    case SET_ALL_IDG_QUESTIONNAIRES:
      if (!state.allIdgQuestionnaires || state.allIdgQuestionnaires.length === 0) {
        newState.allIdgQuestionnaires = payload;
      }

      break;

    case SET_IDG_CONTENT:
      newState.idgContent = payload;
      break;

    case SET_DOCUMENT_ID:
      newState.documentID = payload;
      break;

    case SET_DOCUMENT_DATA:
      newState.documentData = payload;
      break;

    case SET_PATIENT_IDG_MANIFEST:
      newState.patientIdgManifests = payload;
      break;

    case SET_LAST_IDG_INFO:
      newState.lastidgContent = payload;
      break;

    case SET_REVIEW_COMPLETE:
      newState.idgContent.idgReviewComplete = true;
      break;

    case RESET_IDG_DATA:
      newState.idgContent = defaultIDGContent;
      newState.documentID = null;
      newState.documentData = null;
      break;

    case SET_LOADER:
      newState.showLoader = action.payload;
      break;

    case SET_IDG_LIST_DATA:
      newState.idgList = action.payload;
      break;

    default:
      newState = state;
      break;
  }

  return newState;
};
export const IDGGlobalContext = /*#__PURE__*/createContext(initIDGGlobalContext);
export const IDGGlobalDispatchContext = /*#__PURE__*/createContext({});
export const IDGGlobalContextConsumer = IDGGlobalContext.Consumer;
export const IDGGlobalDispatchContextConsumer = IDGGlobalDispatchContext.Consumer;
export const IDGGlobalContextProvider = ({
  observation,
  currentUser,
  patient,
  children
}) => {
  const [{
    idgContent,
    patientIdgManifests,
    lastidgContent,
    allIdgQuestionnaires,
    documentID,
    documentData,
    showLoader,
    idgList
  }, dispatchIDG] = useReducer(IDGGlobalContextReducer, initialState);
  const {
    attestationsDone
  } = useContext(PimMessagingContext);
  useEffect(() => {
    documentID && !documentData && getManifestIDGData();
  }, [documentID]);

  const getManifestIDGData = async () => {
    const IDGData = await (observation === null || observation === void 0 ? void 0 : observation.getIDGDataById(`${documentID}`, (currentUser === null || currentUser === void 0 ? void 0 : currentUser.currentHospiceBin) || ''));

    if (!(IDGData instanceof Response)) {
      dispatchIDG({
        type: SET_DOCUMENT_DATA,
        payload: formatDocumentData(IDGData)
      });
      dispatchIDG({
        type: SET_LOADER,
        payload: false
      });
    }
  };

  const getDocumentList = async () => {
    var _patient$siteId;

    const queryParams = new URLSearchParams(window.location.search);
    const agency = queryParams.get('agency');
    const siteId = (patient === null || patient === void 0 ? void 0 : (_patient$siteId = patient.siteId) === null || _patient$siteId === void 0 ? void 0 : _patient$siteId.toString()) || queryParams.get('siteId') || queryParams.get('siteid');
    const response = observation && (await observation.getManifestItems(agency || '', siteId, patient === null || patient === void 0 ? void 0 : patient.patientNumber, 'idgv2,idgc2,idgv3'));

    if (!(response instanceof Response)) {
      dispatchIDG({
        type: SET_IDG_LIST_DATA,
        payload: response === null || response === void 0 ? void 0 : response.filter(form => form.reverserank === '1')
      });
    }
  };

  useEffect(() => {
    (patient === null || patient === void 0 ? void 0 : patient.patientNumber) && getDocumentList();
  }, []);
  const context = useMemo(() => ({
    idgContent,
    patientIdgManifests,
    lastidgContent,
    documentID,
    documentData,
    allIdgQuestionnaires,
    dispatchIDG,
    showLoader,
    idgList
  }), [idgContent, patientIdgManifests, lastidgContent, documentID, documentData, allIdgQuestionnaires, dispatchIDG, showLoader, idgList]);
  return /*#__PURE__*/React.createElement(IDGGlobalContext.Provider, {
    value: context
  }, children);
};
export function withIDGGlobalContext(Component) {
  return function contextComponent(props) {
    return /*#__PURE__*/React.createElement(IDGGlobalContextConsumer, null, context => /*#__PURE__*/React.createElement(IDGGlobalDispatchContextConsumer, null, dispatchContext => /*#__PURE__*/React.createElement(Component, _extends({}, props, context, dispatchContext))));
  };
}
export default IDGGlobalContext;